import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Hash, checkPermission } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Viewer } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, ViewIcon, Menu as MenuIcons, RestoreIcon } from 'assets/icons';
import { SystemMovementService, ReportService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	client_id: '',
	since: '',
	until: '',
	module_id: ''
}

class SystemMovements extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Cliente',
			'Usuario',
			'Fecha',
			'Hora',
			'Módulo',
			'Descripción'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		clients: [],
		modules: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Reporte de Auditoría',
				onBack: null,
				subtitle: 'Consulta los registros de actividades y cambios realizados en el sistema.',
				color: '#fef8f3',
				icon: MenuIcons.Menu10
			}
		});

		this.load();

		if (this.props.user?.level_id == Constants.LEVELS.ADMIN || this.props.user?.level_id == Constants.LEVELS.MODERATOR) {
			this.loadClients();
		}

		if (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR) {
			let header = [...this.state.header];
			header.shift();
			this.setState({
				header
			});
		}
	}

	loadClients = async () => {
		const res: any = await ReportService.admin.getClients({
			withoutLoading: true
		});
		this.setState({
			clients: res.clients || []
		});
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await SystemMovementService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});

		res.modules = res.modules?.filter((i: any) => {
			if (i.id == Constants.SYSTEM_MOVEMENT_MODULES.KYC && !this.props.user?.has_kyc_plan) {
				return false;
			}
			if (i.id == Constants.SYSTEM_MOVEMENT_MODULES.DOCUMENTS && !this.props.user?.has_document_plan) {
				return false;
			}
			if (i.id == Constants.SYSTEM_MOVEMENT_MODULES.BILLS && !this.props.user?.has_bill_plan) {
				return false;
			}

			return true;
		});

		this.setState({
			data: res.movements?.rows || [],
			last_page: res.movements?.count || 1,
			modules: res.modules || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	render() {
		return (
			<div id="admin-report-system-movements">
				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md">
								<Input
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar"
									label="Buscar por nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md">
								<DatePicker
									label="Desde"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'since'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.since }
								/>
							</div>
							<div className="col-md">
								<DatePicker
									label="Hasta"
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'until'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.until }
								/>
							</div>
							{
								this.props.user?.level_id != Constants.LEVELS.CLIENT && this.props.user?.level_id != Constants.LEVELS.CLIENT_MODERATOR && (
									<div className="col-md">
										<Select
											color="white"
											placeholder="Seleccionar"
											label="Cliente"
											name="client_id"
											onChange={ (e: any) => this.change(e,async () => {
												this.load(true);
											}) }
											value={ this.state.form.client_id }
											options={ this.state.clients.map((item: any) => {
												return {
													value: item.id,
													label: item?.name + ' ' + item?.lastname
												}
											}) } />
									</div>
								)
							}
							<div className="col-md">
								<Select
									color="white"
									placeholder="Seleccionar"
									label="Módulo"
									name="module_id"
									onChange={ (e: any) => this.change(e,async () => {
										this.load(true);
									}) }
									value={ this.state.form.module_id }
									options={ this.state.modules.map((item: any) => {
										return {
											value: item.id,
											label: item?.name
										}
									}) } />
							</div>
						</div>
						<div className="row">
							<div className="col-md-12 text-right">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ RestoreIcon } />
											<p>Limpiar</p>
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table title="Reporte de Auditoría" data={ this.state.data.length } header={ this.state.header }
					pagination={
						<Pagination 
							pages={ this.state.last_page } 
							active={ this.state.page }
							onChange={ async (page: number) => {
								await this.setState({
									page: page
								});
								this.load();
							} } />
					}
				>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index } onClick={ () => {
								let url = null;
								const is_client = (this.props.user?.level_id == Constants.LEVELS.CLIENT || this.props.user?.level_id == Constants.LEVELS.CLIENT_MODERATOR);

								if (i.identity_verification_id) {
									url = (is_client ? '/client/verifications' : '/admin/verifications') + '/view/' + Hash.encryptWithAES(i?.id);
								}
								else if (i.document_verification_id) {
									url = (is_client ? '/client/documents' : '/admin/documents') + '/view/' + Hash.encryptWithAES(i?.id);
								}
								else if (i.config_id) {
									if (i.config?.permission?.type == Constants.CONFIG_TYPES.BILLS) {
										url = (is_client ? '/client/bills/config' : '/admin/bills/config') + (!is_client ? ('?user_id=' + i.owner_id) : '');
									}
									else if (i.config?.permission?.type == Constants.CONFIG_TYPES.DOCUMENTS) {
										url = (is_client ? '/client/documents/config' : '/admin/documents/config') + (!is_client ? ('?user_id=' + i.owner_id) : '');
									}
									else if (i.config?.permission?.type == Constants.CONFIG_TYPES.KYC) {
										url = (is_client ? '/client/verifications/config' : '/admin/verifications/config') + (!is_client ? ('?user_id=' + i.owner_id) : '');
									}
								}

								if (url) {
									window.open(`${window.location.origin}/#` + url,'_blank');
								}
							} }>
								{
									this.props.user?.level_id != Constants.LEVELS.CLIENT && this.props.user?.level_id != Constants.LEVELS.CLIENT_MODERATOR && (
										<td>
											<div className="container-initial">
												<p className="initial">{ (i?.owner?.name + ' ' + i?.owner?.lastname).substr(0,1) }</p>
												<p>{ i?.owner?.name + ' ' + i?.owner?.lastname }</p>
											</div>
										</td>
									)
								}
								<td>
									<p className="bold">{ i?.user?.name + ' ' + i?.user?.lastname }</p>
									<p>{ i?.user?.email }</p>
								</td>
								<td>{ moment(i?.created_at).format('DD/MM/YYYY') }</td>
								<td>{ moment(i?.created_at).format('hh:mm A') }</td>
								<td>
									<div className="container-module" style={{ backgroundColor: i?.module?.secondary_color }}>
										<img src={ Constants.BASE_PUBLIC + i?.module?.icon } />
										<p style={{ color: i?.module?.color }}>{ i?.module?.name || '-' }</p>
									</div>
								</td>
								<td style={{ maxWidth: '400px' }}>{ i?.description }</td>
							</tr>
						)
					}) }
				</Table>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(SystemMovements);